
import Button from "@/components/base/Button"
import InfoMaterialUpload from "@/components/region/InfoMaterialUpload"
import fileService from "@/services/file.service"
import mappingService from "@/services/mapping.service"

export default {
    name: "FilePreviewCard",
    components: { Button, InfoMaterialUpload },
    /** update: indicates that an existing document was updated or a new one was created */
    emits: ["update"],
    props: {
        /** title of the infomaterial */
        title: {
            type: String,
            required: true,
        },
        /** description of the infomaterial */
        description: {
            type: String,
            required: true,
        },
        /** id of the infomaterial (not file) */
        id: {
            type: Number,
            required: true,
        },
        /** file object */
        file: {
            type: Object,
            required: true,
        },
        /** shows if infomterial can be edited */
        editable: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isFileDownloadable() {
            return this.file?.mime_type
        },
        type() {
            return mappingService.mapFileMimeTypes(this.file?.mime_type)
        },
    },
    methods: {
        async onFilePreviewClick() {
            const response = await fileService.getFile(this.file.id)
            let blob = new Blob([response], {
                type: this.file.mime_type,
            })
            const URL = window.URL || window.webkitURL
            // getting the local URL of the downloaded file
            const fileUrl = URL.createObjectURL(blob)
            // creating an invisible <a> element in the root of the page
            const a = document.createElement("a")
            a.style.display = "none"
            a.setAttribute("href", fileUrl)
            // setting the name for the file
            a.setAttribute(
                "download",
                this.file.original_filename || this.title
            )
            // rendering the element
            document.body.appendChild(a)
            // a programmatic click to trigger browser download behaviour
            a.click()
            setTimeout(() => {
                // remove the element and release the URL after the download has started
                document.body.removeChild(a)
                URL.revokeObjectURL(fileUrl)
            }, 100)
        },
    },
}
